import { render, staticRenderFns } from "./CanalCobroForm.vue?vue&type=template&id=985f5c72&scoped=true"
import script from "./CanalCobroForm.vue?vue&type=script&lang=js"
export * from "./CanalCobroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985f5c72",
  null
  
)

export default component.exports